var isUnsafeProperty = {};
export {
  isUnsafeProperty as __exports
};
//# sourceMappingURL=isUnsafeProperty.js.map
